import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@apollo/client";
import classnames from "classnames/bind";
import Image from "next/image";
import { IconS3 } from "@aqar-app/aqar-design-system";
import { GET_GENERIC_BANNER } from "../../../graphql/queries/info";
import {
  getWithoutExpiry,
  storeWithoutExpiry,
} from "../../../lib/localStorage";
import styles from "./genericBanner.module.scss";

const cx = classnames.bind(styles);

const GenericBanner = () => {
  const genericBannerPopupRef = useRef({});
  const [showGenericBanner, setShowGenericBanner] = useState(false);
  const [savedBannerId, setSavedBannerId] = useState(undefined);
  const [genricBannerObject, setGenricBannerObject] = useState({});

  const closeGeniricBanner = () => {
    storeWithoutExpiry("genericBannerId", genricBannerObject?.id);
    setShowGenericBanner(false);
  };

  const handleClickOutside = (event) => {
    if (
      genericBannerPopupRef?.current &&
      !genericBannerPopupRef?.current.contains(event.target)
    ) {
      closeGeniricBanner();
    }
  };

  const handleKeyPressEvent = (event) => {
    if (event.keyCode === 27) {
      closeGeniricBanner();
    }
  };

  useEffect(() => {
    if (!showGenericBanner) return undefined;
    document.body.style.overflow = "hidden";
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("keydown", handleKeyPressEvent, false);

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("keydown", handleKeyPressEvent, false);
    };
  }, [showGenericBanner]);

  useEffect(() => {
    const id = getWithoutExpiry("genericBannerId");
    if (id) setSavedBannerId(id);
  }, []);

  useQuery(GET_GENERIC_BANNER, {
    onCompleted: (res) => {
      const genericBanner = res?.Info?.configurations?.generic_banner;
      const obj = genericBanner ? JSON.parse(genericBanner) : {};
      setGenricBannerObject({ ...obj });
      if (savedBannerId !== obj.id && obj.enable) {
        setShowGenericBanner(true);
      }
    },
  });

  if (!genricBannerObject?.enable || savedBannerId === genricBannerObject?.id) {
    return <></>;
  }

  const genericBannerMessage = genricBannerObject?.ar?.message;
  const { title, text, image, table, notes } = genericBannerMessage || {};

  return (
    showGenericBanner && (
      <div className={styles.container}>
        <div
          className={cx("overlay", {
            hidden: !showGenericBanner,
          })}
        />
        <div
          className={cx("popupContainer", {
            hidden: !showGenericBanner,
          })}
          ref={genericBannerPopupRef}
        >
          <div className={styles.nationalHeader}>
            <h1 className={styles.title}>{title}</h1>
            <IconS3
              className={styles.closeIcon}
              type="Close"
              onClick={closeGeniricBanner}
              size="x-small"
            />
          </div>
          <div>
            <div className={styles.nationalImage}>
              <Image src={image} alt="national" layout="fill" />
            </div>
            <p className={styles.nationalOfferText}>{text}</p>
            <table className={styles.nationalTable}>
              {table?.map((offer) => {
                return (
                  <tr
                    className={styles.nationalTableRow}
                    key={`row${offer?.key}`}
                  >
                    <td className={styles.label}>{offer?.key}</td>
                    <td className={styles.value}>{offer?.value}</td>
                  </tr>
                );
              })}
            </table>
            {notes?.map((note) => (
              <small className={styles.nationalNote} key={`note${note}`}>
                {note}
              </small>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default GenericBanner;
